var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "overflow-hidden",
      attrs: { height: _vm.fullHeight, flat: "" },
    },
    [
      _c("v-speed-dial", {
        attrs: {
          direction: "right",
          absolute: "",
          left: "",
          top: "",
          "open-on-hover": "",
          transition: "slide-x-transition",
        },
        scopedSlots: _vm._u([
          {
            key: "activator",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  { staticClass: "toolbar-bg", attrs: { fab: "", small: "" } },
                  [_c("v-icon", [_vm._v(" mdi-eye ")])],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "toolbar-bg",
                                  attrs: { fab: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.mode = "map"
                                    },
                                  },
                                },
                                on
                              ),
                              [_c("v-icon", [_vm._v("mdi-earth")])],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [_c("span", [_vm._v("Map view")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "toolbar-bg",
                                  attrs: { fab: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.mode = "diagram"
                                    },
                                  },
                                },
                                on
                              ),
                              [_c("v-icon", [_vm._v("mdi-lan")])],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [_c("span", [_vm._v("Diagram view")])]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.fab,
          callback: function ($$v) {
            _vm.fab = $$v
          },
          expression: "fab",
        },
      }),
      _vm.mode === "diagram"
        ? _c(
            "v-btn",
            {
              staticClass: "toolbar-bg bottom-legend-toggle",
              attrs: {
                elevation: _vm.showLabels ? 2 : 0,
                fab: "",
                "x-small": "",
                right: "",
                absolute: "",
                icon: !_vm.showLabels,
              },
              on: {
                click: function ($event) {
                  _vm.showLabels = !_vm.showLabels
                },
              },
            },
            [
              _c("v-icon", [
                _vm._v(
                  _vm._s(
                    _vm.showLabels ? "mdi-alphabetical" : "mdi-alphabetical-off"
                  )
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-fab-transition",
        [
          _c(
            "v-tooltip",
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.drawer,
                                expression: "!drawer",
                              },
                            ],
                            staticClass: "toolbar-bg bottom-plus",
                            attrs: {
                              fab: "",
                              small: "",
                              absolute: "",
                              right: "",
                            },
                            on: { click: _vm.plusClick },
                          },
                          on
                        ),
                        [_c("v-icon", [_vm._v("mdi-plus")])],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [_c("span", [_vm._v("Add item")])]
          ),
        ],
        1
      ),
      _c("Drawer", {
        attrs: { item: _vm.formData },
        on: {
          "update:item": function ($event) {
            _vm.formData = $event
          },
          cancel: _vm.cancelForm,
          save: _vm.saveForm,
        },
        model: {
          value: _vm.drawer,
          callback: function ($$v) {
            _vm.drawer = $$v
          },
          expression: "drawer",
        },
      }),
      _c(
        "v-card",
        { staticClass: "overflow-hidden", attrs: { height: "100%", flat: "" } },
        [
          _vm.mode === "diagram"
            ? _c("Diagram", {
                attrs: {
                  "current-case": _vm.currentCase,
                  "use-nodes-coordinates": _vm.useNodesCoordinates,
                  "show-labels": _vm.showLabels,
                },
                on: {
                  change: _vm.diagramChange,
                  "update-breakers": function ($event) {
                    return _vm.diagramChange("breakers")
                  },
                },
              })
            : _vm._e(),
          _vm.mode === "map"
            ? _c("Map", {
                attrs: {
                  "current-case": _vm.currentCase,
                  "use-nodes-coordinates": _vm.useNodesCoordinates,
                  "map-center": _vm.mapCenter,
                  item: _vm.formData,
                },
                on: {
                  "update:currentCase": function ($event) {
                    _vm.currentCase = $event
                  },
                  "update:current-case": function ($event) {
                    _vm.currentCase = $event
                  },
                  "update:mapCenter": function ($event) {
                    _vm.mapCenter = $event
                  },
                  "update:map-center": function ($event) {
                    _vm.mapCenter = $event
                  },
                  "update:item": function ($event) {
                    _vm.formData = $event
                  },
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                  "update:node-positions": _vm.saveNodesPositions,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("img", {
        staticClass: "logo logo-control",
        attrs: { src: require("@/assets/rex-logo.png"), alt: "Acelerex" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }